export const selectPatients = (state) => {
    return state.patients;
}
